import React from 'react';
import { Preferences } from './Preferences';

const Settings = () => {
    return (
        <>
            <Preferences />
        </>
    );
};

export default Settings;
